import {AbstractEvent} from "@/modules/base/events";
import {TransferListing} from "@/modules/transfer-market/entity";
import {Player} from "@/modules/team/entity";

export class BeforeTransferOfferCreateEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public listing?: TransferListing,
  ) {
    super();
  }
}